import type { AddinCommandSurfaceItem } from 'owa-addins-types';
import { ContextualMenuItemType } from '@fluentui/react/lib/ContextualMenu';
import { convertToIContextualMenuItem } from 'owa-addins-core';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';

export interface AddinCount {
    overflow: number;
}

export default function (
    addin: AddinCommandSurfaceItem,
    pinnedAddinKeys: string[],
    hostItemIndex: string,
    className: any,
    addinCount: AddinCount,
    disabled?: boolean
): FilterableMenuItem {
    convertToIContextualMenuItem(hostItemIndex, addin);
    let filterableMenuItem: FilterableMenuItem;
    if (addin.itemType == ContextualMenuItemType.Divider) {
        // If the addin is a divider, only add it if we have other overflow items.
        if (addinCount.overflow > 0) {
            filterableMenuItem = new FilterableMenuItem({
                [FilterableMenuItemArgs.name]: '-',
                [FilterableMenuItemArgs.icon]: '-',
                [FilterableMenuItemArgs.displayOption]: DisplayOption.Overflow,
                [FilterableMenuItemArgs.disabled]: disabled,
            });
        }
    } else {
        let displayOption = DisplayOption.Overflow;
        if (pinnedAddinKeys.indexOf(addin.key) >= 0) {
            displayOption = DisplayOption.Left;
        } else {
            addinCount.overflow++;
        }
        filterableMenuItem = new FilterableMenuItem({
            [FilterableMenuItemArgs.name]: addin.name,
            [FilterableMenuItemArgs.icon]: addin.icon,
            [FilterableMenuItemArgs.onClick]: addin.onClick,
            [FilterableMenuItemArgs.displayOption]: displayOption,
            [FilterableMenuItemArgs.disabled]: disabled,
            [FilterableMenuItemArgs.subMenuProps]: addin.subMenuProps,
            [FilterableMenuItemArgs.id]: addin.id,
            [FilterableMenuItemArgs.key]: addin.key,
            [FilterableMenuItemArgs.onRender]: addin.onRender
                ? (item: any) => {
                      return addin.onRender;
                  }
                : null,
            [FilterableMenuItemArgs.checked]: addin.checked,
            [FilterableMenuItemArgs.ariaLabel]: addin.ariaLabel,
            [FilterableMenuItemArgs.title]: '',
            [FilterableMenuItemArgs.className]: className,
            [FilterableMenuItemArgs.canCheck]: addin.canCheck,
            [FilterableMenuItemArgs.iconOnly]: true,
        });
        filterableMenuItem.iconProps = addin.iconProps;
    }
    return filterableMenuItem;
}
